document.addEventListener('DOMContentLoaded', function () {

    const carouselContainer = document.querySelector('.carousel-container');

    if (!carouselContainer) {
        return;
    }

    const isMobile = window.matchMedia('(max-width: 768px)').matches; // Detectar si es móvil
    const mobileCarousel = document.querySelector('.carousel-images.mobile-images');
    const desktopCarousel = document.querySelector('.carousel-images.desktop-images');
    const videoElement = mobileCarousel ? mobileCarousel.querySelector('video') : null;
    const images = isMobile ? mobileCarousel.querySelectorAll('img') : desktopCarousel.querySelectorAll('img');

    let currentIndex = 0;

    function showSlide(index) {
        // Ocultar todas las diapositivas
        if (isMobile) {
            if (videoElement) videoElement.style.display = 'none';
            images.forEach(img => img.style.display = 'none');
        } else {
            images.forEach(img => img.style.display = 'none');
        }

        // Mostrar la diapositiva actual
        if (isMobile && index === 0 && videoElement) {
            videoElement.style.display = 'block';
        } else {
            images[index - (isMobile && videoElement ? 1 : 0)].style.display = 'block';
        }
    }

    function nextSlide() {
        if (isMobile && currentIndex === 0 && videoElement) {
            // Si estamos en la versión móvil y el video está en reproducción
            if (videoElement.ended || videoElement.duration === Infinity) {
                currentIndex++;
                showSlide(currentIndex);
            } else {
                // Esperar a que termine el video
                setTimeout(nextSlide, 100); // Revisar cada 100ms
            }
        } else {
            currentIndex++;
            if (currentIndex >= images.length + (isMobile && videoElement ? 1 : 0)) {
                currentIndex = 0; // Volver al inicio
            }
            showSlide(currentIndex);
        }
    }

    function startCarousel() {
        showSlide(currentIndex);

        setInterval(() => {
            nextSlide();
        }, 5000); // Cambiar cada 5 segundos
    }

    if (carouselContainer) {
        startCarousel();
    }
});
